import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.AccountBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.ACCOUNT_CONTROL) {
    throw new Error('Expected a valid AccountControl control')
  }

  const upAccountField = (field: string) => ({
    display: uischema.options?.fields?.[field] ? true : false,
    required: uischema.options?.fields?.[field]?.required || false
  })

  return {
    type: next.BLOCK_TYPE.ACCOUNT,
    required: false, // can never be required
    settings: {
      ...upCommonSettings(uischema),
      purposeLabels: uischema.options?.purposeLabels ?? [],
      fields: {
        email: upAccountField('email'),
        telephone: upAccountField('telephone'),
        companyName: upAccountField('companyName'),
        registryCourt: upAccountField('registryCourt'),
        registerNumber: upAccountField('registerNumber')
      }
    }
  }
}
